// Los KPIs de estado de una lista con ciclo de vida, contados sobre lo ya cargado.
import type { KpiItem } from '@/shared/patterns/KpiBar';
import { LIFECYCLE_KPI_HELP } from './helpText';
import type { LifecycleStatus } from './lifecycleStatus';

export interface LifecycleKpiCounts {
    active: number;
    scheduled: number;
    paused: number;
    draft: number;
}

/** Cuenta los estados; una permanente es una activa sin fin. */
export function countLifecycleStatuses(statuses: Iterable<LifecycleStatus>): LifecycleKpiCounts {
    const counts: LifecycleKpiCounts = { active: 0, scheduled: 0, paused: 0, draft: 0 };
    for (const status of statuses) {
        if (status === 'ACTIVE' || status === 'PERMANENT') counts.active += 1;
        else if (status === 'SCHEDULED') counts.scheduled += 1;
        else if (status === 'PAUSED') counts.paused += 1;
        else if (status === 'DRAFT') counts.draft += 1;
    }
    return counts;
}

/** Activas · Programadas · Pausadas · Borradores, con el mismo texto y color en todas las pantallas. */
export function lifecycleKpiItems(
    counts: LifecycleKpiCounts | null,
    options: { activeSub?: string } = {},
): KpiItem[] {
    const value = (count: number | undefined) => (count === undefined ? '—' : count);
    return [
        {
            label: 'Activas',
            value: value(counts?.active),
            sub: options.activeSub,
            tone: 'success',
            help: LIFECYCLE_KPI_HELP.active,
        },
        {
            label: 'Programadas',
            value: value(counts?.scheduled),
            sub: 'arrancan próximamente',
            tone: 'info',
            help: LIFECYCLE_KPI_HELP.scheduled,
        },
        {
            label: 'Pausadas',
            value: value(counts?.paused),
            sub: 'reanudar o vencer',
            tone: 'warning',
            help: LIFECYCLE_KPI_HELP.paused,
        },
        {
            label: 'Borradores',
            value: value(counts?.draft),
            sub: 'sin publicar',
            help: LIFECYCLE_KPI_HELP.draft,
        },
    ];
}
